import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';

import { ExtendAndOverride } from '../../utils/ExtendAndOverride';

interface OwnProps {
  children: React.ReactNode;
}

export type BadgeProps = ExtendAndOverride<OwnProps, Omit<BoxProps, 'css'>>;

export const Badge = (props: BadgeProps): JSX.Element => {
  return <Box minHeight="24px" borderRadius="12px" fontSize="12px" display="flex" alignItems="center" {...props} />;
};
